import { Typography, Button } from "../../components"
import "./styles.css";

export default function StappenplanSubsidieverzoek(props) {
    return (
        <div className="container">
            <iframe
                title="Stappenplan subsidieverzoek NOLIA BabyFeeding"
                src="https://app.enormail.eu/subscribe/9bd33f95c79e74052708962ded602f8a"
                style={{
                width: "100%",
                height: "100vh",
                border: "none"
                }}
                allow="fullscreen; payment"
            ></iframe>
        </div>
    )
}